import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MbscSelectOptions } from '@mobiscroll/angular';
import { PDxListItem, PDxLists } from 'src/app/core/PDxListItem.model';
import { PDxUserPermission } from 'src/app/core/PDxUserPermission.enum';
import { LocalDatePipe } from 'src/app/core/pipes.model';
import { ajaxCall, DataTablesResponse } from 'src/app/core/services/ajax-call.service';
import { UserSummary } from '../models/user-summary.model';
import { TableSorting } from 'src/app/core/tableSorting.component';
import { UserPropertiesComponent } from '../../core/user-properties/user-properties.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { ConfirmService } from 'src/app/core/services/confirm.service';
import { DeleteUserComponent } from '../delete-user/delete-user.component';
import { NgForm } from '@angular/forms';
import { ListFilter } from 'src/app/core/list-filter.model';
import { DirtyTrackingService } from 'src/app/core/dirty-tracking/dirty-tracking.service';
import { ViewUserAssignmentListComponent } from '../view-user-assignment-list/view-user-assignment-list.component';
import { MbscSelectOnFilterEvent } from '@mobiscroll/angular/dist/js/core/components/select/select';
import { SelectedUsersService } from '../services/selected-users.service';
import { CloneService } from 'src/app/core/services/clone.service';
import { MessageUsersComponent } from '../message-users/message-users.component';
import { SyncFavoritesComponent } from '../sync-favorites/sync-favorites.component';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styles: []
})
export class UserListComponent implements OnInit {

  @ViewChild('exportForm') exportForm: ElementRef;

  showList: boolean = false;
  accounts: PDxListItem<string>[] = [];
  pdxUserPermission = PDxUserPermission;
  filterCount: number = 0;
  selectOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.accounts = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: null, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.accounts = data;
            if (this.accounts.filter((x) => x.value == this.filter.accountId).length == 0) {
              this.filter.accountId = null;
            }
          }
        }, () => { });
      } else {
        if (this.accounts.filter((x) => x.value == this.filter.accountId).length == 0) {
          this.filter.accountId = null;
        }
      }
      return false;
    },
    onChange: (event, inst) => {
      this.hideTheList();
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.accounts = [];
        this.entities = [];
        this.filter.accountId = null;
        this.filter.entityId = null;
        this.hideTheList();
      }
    }]
  };
  entities: PDxListItem<string>[] = [];
  parentOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.entities = [];
      if (!this.filter.accountId) {
        return false;
      }
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: this.filter.accountId, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.entities = data;
            //            this.validateCurrentParent();
          }
        }, () => { });
      } else {
        //        this.validateCurrentParent();
      }
      return false;
    },
    onChange: (ev: any) => {
      this.hideTheList();
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.entities = [];
        this.filter.entityId = null;
        this.hideTheList();
      }
    }]
  };

  filter: UserListFilter;
  results: DataTablesResponse<UserSummary>;
  userPermissionList: PDxListItem<string>[] = [];

  constructor(private ajax: ajaxCall,
    private modalService: NgbModal,
    private notifier: NotifierService,
    private dirtyService: DirtyTrackingService,
    private cloneService: CloneService,
    private selectedUserService: SelectedUsersService,
    private confirm: ConfirmService) { }

  ngOnInit(): void {
    this.accounts = [];
    this.userPermissionList.push({ value: null, text: 'Any' });
    this.userPermissionList.push({ value: 'pdxAdmin', text: 'PDx Admin' });
    PDxLists.PDxUserPermissions().forEach(x => {
      this.userPermissionList.push({ value: 'customer:' + x.value, text: x.text });
    });

    this.resetFilters();
  }

  resetFilters(): void {
    this.filter = new UserListFilter(8, 'Name', 'asc');
    this.filter.userStatus = this.statusFilters.filter(x => x.value === true)[0];
    this.filter.userPermission = this.userPermissionList[0];
    this.hideTheList();
  }

  showTheList(): void {
    if (!this.showList) {
      this.loadList(true);
    }
  }

  hideTheList(): void {
    this.showList = false;
  }

  loadList = (reset: boolean = false) => {
    if (reset) {
      this.filter.page = 1;
    }
    this.ajax.MakeCall<DataTablesResponse<UserSummary>>('/User/FullList', this.filter).then(results => {
      this.results = results;
      this.showList = true;
    }, () => { });
  }

  inputFieldChange(ev: KeyboardEvent): void {
    if (ev.key == 'Enter') {
      this.showTheList();
    }
  }

  viewUser(userId: string): void {
    const modal = this.modalService.open(UserPropertiesComponent, { size: 'lg', beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.componentInstance.userId = userId;
    modal.result.then(() => { this.loadList(); }, () => { });
  }

  viewUserPermissions(userId: string): void {
    const modal = this.modalService.open(ViewUserAssignmentListComponent, { size: 'xl' });
    modal.componentInstance.userId = userId;
    modal.result.then(() => { this.loadList(); }, () => { });
  }

  impersonateUser(userId: string): void {
    this.ajax.MakeCall<boolean>('/User/Impersonate', { userId: userId }).then(() => {
      window.location.href = window.location.origin + '/customer';
    }, () => { });
  }

  sendPasswordReset(userId: string): void {
    this.confirm.confirm('Send Password Reset', 'Are you sure you want to send this user an email?').then(() => {
      this.ajax.MakeCall<boolean>('/User/ResetEmail', { userId: userId }).then(() => {
        this.notifier.notify('info', 'This user has been sent a Password Reset email');
      }, () => { });
    }, () => { });
  }

  activateUser(userId: string): void {
    this.confirm.confirm('Activate User', 'Are you sure you want to activate this user?').then(() => {
      this.ajax.MakeCall<boolean>('/User/Activate', { userId: userId }).then(() => {
        this.notifier.notify('info', 'This user has been activated');
        this.loadList();
      }, () => { });
    }, () => { });
  }

  deleteUser(userId: string): void {
    const modal = this.modalService.open(DeleteUserComponent);
    modal.componentInstance.userId = userId;
    modal.result.then(() => { this.loadList(); }, () => { });
  }

  statusFilters: PDxListItem<boolean>[] = [
    { value: null, text: 'Any' },
    { value: true, text: 'Active' },
    { value: false, text: 'Deactivated' }
  ];
  selectStatusFilter(f: PDxListItem<boolean>): void {
    this.filter.userStatus = f;
    this.hideTheList();
  }

  selectUserPermission(f: PDxListItem<string>): void {
    this.filter.userPermission = f;
    this.hideTheList();
  }

  exportUsers(): void {
    this.exportForm.nativeElement.submit();
  }

  selectAll(): void {
    var allFilter = this.cloneService.deepClone<UserListFilter>(this.filter);
    allFilter.page = 1;
    allFilter.pageSize = this.results.recordsFiltered;
    this.ajax.MakeCall<DataTablesResponse<UserSummary>>('/User/FullList', allFilter).then(results => {
      results.data.forEach(element => {
        this.selectedUserService.AddUserSummary(element);
      });
    }, () => { });

  }

  messageUsers(): void {
    const modal = this.modalService.open(MessageUsersComponent, { size: 'xl', windowClass: 'notify-modal', beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.result.then(() => { }, () => { });
  }

  syncFavorites(userId: string) {
    const modal = this.modalService.open(SyncFavoritesComponent, { beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.componentInstance.userId = userId;
    modal.result.then(() => { }, () => { });
  }
}

export class UserListFilter extends ListFilter {
  nameFilter?: string;
  accountId?: string;
  entityId?: string;
  userStatus?: PDxListItem<boolean>;
  userPermission?: PDxListItem<string>;
}